import React from 'react';

interface UserAvatarProps {
    photoUrl?: string | null;
    name?: string | null;
    email?: string | null;
    className?: string;
    title?: string;
    alt?: string;
}

function getInitials(name?: string | null, email?: string | null): string {
    const displayName = (name || '').trim();
    const emailName = (email || '').split('@')[0].trim();
    const source = displayName || emailName;

    if (!source) return '?';

    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return `${Array.from(parts[0])[0] || ''}${Array.from(parts[1])[0] || ''}`.toUpperCase();
    }

    return Array.from(source).slice(0, 2).join('').toUpperCase();
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ photoUrl, name, email, className, title, alt }) => {
    const [hasImageError, setHasImageError] = React.useState(false);
    const normalizedPhotoUrl = (photoUrl || '').trim();
    const shouldShowImage = normalizedPhotoUrl !== '' && !hasImageError;

    React.useEffect(() => {
        setHasImageError(false);
    }, [normalizedPhotoUrl]);

    return (
        <div className={className} title={title || name || email || undefined} aria-label={alt || name || email || 'User avatar'}>
            {shouldShowImage ? (
                <img
                    src={normalizedPhotoUrl}
                    alt={alt || name || email || 'User avatar'}
                    onError={() => setHasImageError(true)}
                    referrerPolicy="no-referrer"
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 'inherit',
                        objectFit: 'cover',
                        display: 'block'
                    }}
                />
            ) : (
                getInitials(name, email)
            )}
        </div>
    );
};
